// Cap for creator-facing message bodies, shared by the message-template API
// validator and the frontend inputs (composer, direct-message dialogs, chat) via
// `@unbox/api`. Counts UTF-16 code units, matching the HTML maxLength attribute.
export const MAX_MESSAGE_TEMPLATE_LENGTH = 5000;
